<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" selector :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="采购退货单号">
                            <c-input name="return_code"></c-input>
                        </m-search-item>
                        <m-search-item label="关联单据">
                            <c-input name="purchase_code"></c-input>
                        </m-search-item>
                        <m-search-item label="退货人信息">
                            <c-input name="returnee_info"></c-input>
                        </m-search-item>
                        <m-search-item label="退货地址">
                            <c-input name="returnee_address"></c-input>
                        </m-search-item>
                        <m-search-item label="退货快递单号">
                            <c-input name="express_no"></c-input>
                        </m-search-item>
                        <m-search-item label="申请时间">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button color="main" v-if="auth('b_online_purchase_return_confirm')" prepend-icon="tf-check" @click="batchConfirmReturn()">批量确认退货</c-button>
                    <c-button prepend-icon="tf-export"  v-if="auth('b_online_purchase_return_export')" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <template #return_state="{data}">
                    <c-state tag async dict="PURCHASE_RETURN_STATE" :value="data.return_state"></c-state>
                </template>

                <template #return_count="{data}">
                    {{data.return_count || 0}}
                </template>

                <template #returnee_info="{data}">
                    {{data.returnee_name || '-'}} {{data.returnee_phone || ''}}
                </template>

                <c-table-column type="button" label="操作" width="180" button-limit="6">
                    <template #default="{data}">
                        <c-table-button icon="tf-detail" @click="openDetail(data)">查看</c-table-button>
                        <c-table-button v-if="auth('b_online_purchase_return_edit_adderss') && Number(data.return_state) === 1" icon="tf-edit" @click="editReturnInfo(data)">修改退货信息</c-table-button>
                        <c-table-button v-if="auth('b_online_purchase_return_confirm') && Number(data.return_state) === 1"  icon="tf-accept" @click="confirmReturn(data)">确认退货</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'

export default {
    computed: {
        ...mapState(['saasInfo'])
    },

    data() {
        return {
            workType: 42
        }
    },

    methods: {
        openDetail(data) {
            this.globalDialog('purchaseReturnDetail', {
                props: {
                    id: data.id
                }
            }, () => {
                this.$refs.view.update();
            });
        },

        editReturnInfo(data) {
            this.globalDialog('purchaseReturnEdit', {
                data: {
                    returnOrder: data
                }
            }, () => {
                this.$refs.view.update();
            });
        },

        confirmReturn(data) {
            this.globalDialog('purchaseReturnConfirm', {
                data: {
                    returnOrders: [data]
                }
            }, () => {
                this.$refs.view.update();
            });
        },

        batchConfirmReturn(data) {
            var flag = true;
            var list = [];
            if(data){
                list.push(data);
            }else {
                list = this.$refs.view.$refs.list.getData('selected');
                if (!list || list.length == 0){
                    this.$message({
                        message: '请选择需要操作的记录',  // 提示内容,
                        type: 'warn'
                    });
                    flag = false;
                    return;
                }
                list.forEach(item => {
                    if (item.return_state != 1) {
                        this.$message({
                            message: '请选择“待退货”状态的采购退货单进行操作',  // 提示内容,
                            type: 'warn'
                        });
                        flag = false;
                        return
                    }
                });
                const addressList = [...new Set(list.map(item => item.returnee_address || ''))];
                if (addressList.length > 1) {
                    this.$message({message: '批量确认仅支持退货地址完全相同的采购退货单', type: 'warn'});
                    flag = false;
                    return;
                }
            }
            if (flag){
                this.globalDialog('purchaseReturnConfirm', {
                    data: {
                        returnOrders: list
                    }
                }, () => {
                    this.$refs.view.update();
                });
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
.return-state {
    display inline-block
    padding 2px 7px
    border-radius 2px
    font-size 12px
    line-height 18px
}

.is-pending {
    color #4775ff
    background #eff3ff
}

.is-returned {
    color #777
    background #f5f5f5
}
</style>
